import request from '@/common/request'

export default {
    /**
    *  create 增
    *  delete 删
    *  update 改
    *  query  查
    */
     querySecretBatch: (params) => {
        return request({
            url: '/v1/secretBatch',
            method: 'get',
            params
        })
    },
    createSecretBatch: (data) => {
        return request({
            url: '/v1/secretBatch',
            method: 'post',
            data
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/modules/secretBatch.js